/* tslint:disable:no-console */
var MockStaticPane = /** @class */ (function () {
    function MockStaticPane() {
    }
    MockStaticPane.prototype.show = function (params, element, showCb) {
        console.log('show', params);
        var elements = Array.prototype.slice.call(element.children);
        for (var index in elements) {
            if (elements.hasOwnProperty(index)) {
                document.body.appendChild(elements[index]);
            }
        }
        if (showCb) {
            showCb();
        }
    };
    MockStaticPane.prototype.hide = function (params) {
        console.log('hide', params);
    };
    MockStaticPane.prototype.destroy = function (params) {
        console.log('destroy', params);
    };
    return MockStaticPane;
}());
export { MockStaticPane };
